import type { TFunction } from 'i18next'
import type { PackagingComponent } from '@/shared/hooks/api/packagingSuppliers'
import type { ComponentEditorLabels } from '@/shared/components/packaging/componentEditorTypes'
import { getMaterialLabel } from '@/shared/components/packaging/componentEditorUtils'
import {
  RECYCLABILITY_ASSESSMENT_DOCUMENT_SECTION_3_GROUPS,
  type RecyclabilityAssessmentDocumentProseCriterionKey,
  type RecyclabilityAssessmentDocumentSection3Row,
} from './recyclabilityAssessmentDocumentSection3'

export type RecyclabilityAssessmentDocumentProseByCriterion = Record<
  RecyclabilityAssessmentDocumentProseCriterionKey,
  { en: string; zh: string }
>

export function formatRecyclabilityAssessmentDocumentMaterialsSummary(
  components: PackagingComponent[],
  labels: ComponentEditorLabels
): string {
  if (components.length === 0) {
    return '—'
  }
  const uniqueMaterials = new Set<string>()
  for (const component of components) {
    uniqueMaterials.add(getMaterialLabel(component.material, labels))
  }
  return [...uniqueMaterials].join(', ')
}

function pickProseLocale(
  locale: string,
  bilingual: { en: string; zh: string }
): string {
  if (locale.startsWith('zh')) {
    return bilingual.zh
  }
  return bilingual.en
}

export function resolveRecyclabilityAssessmentDocumentSection3Response(
  row: RecyclabilityAssessmentDocumentSection3Row,
  translate: TFunction<'packagingSuppliers'>,
  locale: string,
  generatedProse: RecyclabilityAssessmentDocumentProseByCriterion | null
): string {
  if (row.generatedProseKey != null) {
    const entry = generatedProse?.[row.generatedProseKey]
    if (entry != null) {
      return pickProseLocale(locale, entry)
    }
    return '—'
  }
  return translate(row.responseKey)
}

export { RECYCLABILITY_ASSESSMENT_DOCUMENT_SECTION_3_GROUPS }
